/* ============================================================================
   WAITLIST — Figma 1126:87087 (Availability): the sold-out CTA's drawer
   (Waitlist Drawer D 1143:89173 · M 1143:89183) and its success state
   (D 1155:92996 · M 1155:92931), on the shared drawer shell.

   SELLING OUT...SUCKS, the variant the shopper picked (photo, name, colour ·
   size · length), EMAIL ADDRESS and KEEP ME POSTED. The address is checked
   on submit, not while typing; a bad one shows the form's error and shakes
   the field. A good one "sends" for a beat, then the form folds away and the
   green confirmation rises in with a drawn check, CLOSE beneath it. Signing
   up is remembered per variant, so reopening it shows the confirmation.
   Nothing is sent anywhere — this is a prototype.
   ========================================================================== */

import { animate, stagger, MO, state, play, $ } from './mo.js';
import { createDrawer } from './drawers.js';
import { SIZE_NAMES } from './data.js';
import { shake, announce } from './ui.js';

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

const drawerHTML = () => `
  <div class="drawer drawer--waitlist" data-drawer="waitlist" hidden>
    <div class="drawer__scrim" data-drawer-scrim></div>
    <div class="drawer__panel" role="dialog" aria-modal="true" aria-labelledby="wl-title" aria-describedby="wl-lede" tabindex="-1" data-drawer-panel>
      <div class="wl">
        <div class="wl__head">
          <h2 class="wl__title" id="wl-title">Selling Out...Sucks</h2>
          <button class="wl__close" type="button" aria-label="Close waitlist" data-drawer-close>
            <img src="assets/figma/icon-close.svg" alt="" width="24" height="24">
          </button>
        </div>
        <p class="wl__lede" id="wl-lede">Share your email to get updates on the color and size you need.</p>
        <hr class="wl__rule">
        <div class="wl__product">
          <span class="wl__media"><img class="wl__img" alt="" width="160" height="213" data-wl-img></span>
          <p class="wl__name" data-wl-name></p>
          <p class="wl__variant" data-wl-variant></p>
        </div>
        <hr class="wl__rule">
        <div class="wl__swap" data-wl-swap>
          <form class="wl__form" novalidate data-wl-form>
            <label class="wl__label" for="wl-email">Email Address</label>
            <input class="wl__input" id="wl-email" name="email" type="email" inputmode="email" autocomplete="email"
              placeholder="Enter email here" required aria-describedby="wl-error" data-wl-email data-autofocus>
            <p class="wl__error" id="wl-error" hidden data-wl-error>
              <img src="assets/figma/icon-warning.svg" alt="" width="16" height="16">
              <span>Please enter a valid email address.</span>
            </p>
            <button class="ui-btn ui-btn--solid wl__btn" type="submit" data-wl-submit><span class="wl__btn-label" data-wl-submit-label>Keep Me Posted</span></button>
          </form>
          <div class="wl__done" hidden data-wl-done>
            <p class="wl__toast" role="status" tabindex="-1" data-wl-toast>
              <svg class="wl__tick" viewBox="0 0 20 20" width="20" height="20" aria-hidden="true"><circle cx="10" cy="10" r="8.25" fill="none" stroke="currentColor" stroke-width="1.5" pathLength="1"/><path d="M6.2 10.4l2.6 2.6 5-5.6" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" pathLength="1"/></svg>
              <span>You’ve successfully signed up for our waitlist.</span>
            </p>
            <button class="ui-btn ui-btn--outline wl__btn" type="button" data-drawer-close>Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>`;

export function initWaitlist({ product }) {
  document.body.insertAdjacentHTML('beforeend', drawerHTML());
  const root = $('[data-drawer="waitlist"]');
  const drawer = createDrawer(root);
  const img = $('[data-wl-img]', root);
  const nameEl = $('[data-wl-name]', root);
  const variant = $('[data-wl-variant]', root);
  const form = $('[data-wl-form]', root);
  const email = $('[data-wl-email]', root);
  const error = $('[data-wl-error]', root);
  const submit = $('[data-wl-submit]', root);
  const submitLabel = $('[data-wl-submit-label]', root);
  const done = $('[data-wl-done]', root);
  const toast = $('[data-wl-toast]', root);
  const swap = $('[data-wl-swap]', root);

  const joined = new Set(); // colour·size·length the shopper is on the list for
  let key = '';
  let sending = false;

  const setError = (on) => {
    email.setAttribute('aria-invalid', String(on));
    if (on === !error.hidden) return;
    if (on) {
      error.hidden = false;
      play(error, { opacity: [0, 1], y: [-4, 0] }, { duration: MO.base, ease: MO.eEntrance });
    } else {
      play(error, { opacity: [1, 0] }, { duration: MO.quick, ease: MO.eExit })?.finished.then(() => { error.hidden = email.getAttribute('aria-invalid') !== 'true'; });
    }
  };
  email.addEventListener('input', () => { if (email.getAttribute('aria-invalid') === 'true' && EMAIL.test(email.value.trim())) setError(false); });

  function showDone({ instant = false } = {}) {
    form.hidden = true;
    done.hidden = false;
    const tick = [...toast.querySelectorAll('.wl__tick *')];
    if (instant || state.reduced) {
      tick.forEach((p) => animate(p, { pathLength: 1 }, { duration: 0 }));
      return;
    }
    play(toast, { opacity: [0, 1], y: [MO.riseSm, 0], scale: [0.98, 1] }, { duration: MO.slow, ease: MO.eEntrance });
    play($('.ui-btn', done), { opacity: [0, 1], y: [MO.riseXs, 0] }, { duration: MO.base, ease: MO.eEntrance, delay: 0.12 });
    animate(tick[0], { pathLength: [0, 1] }, { duration: MO.slow, ease: MO.eEntrance, delay: 0.1 });
    animate(tick[1], { pathLength: [0, 1] }, { duration: MO.base, ease: MO.eEntrance, delay: 0.32 });
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (sending) return;
    const value = email.value.trim();
    if (!EMAIL.test(value)) {
      setError(true);
      shake(email);
      email.focus();
      announce('Please enter a valid email address.');
      return;
    }
    setError(false);
    sending = true;
    submit.setAttribute('aria-busy', 'true');
    /* a beat of "sending": the label steps aside for three dots */
    await play(submitLabel, { opacity: [1, 0], y: [0, -6] }, { duration: MO.quick, ease: MO.eExit })?.finished;
    submitLabel.innerHTML = '<span class="wl__dots" aria-hidden="true"><i></i><i></i><i></i></span><span class="u-sr">Signing you up</span>';
    play(submitLabel, { opacity: [0, 1], y: [6, 0] }, { duration: MO.base, ease: MO.eEntrance });
    await new Promise((r) => setTimeout(r, state.reduced ? 300 : 900));
    joined.add(key);
    /* the form folds away under the confirmation: the swap area holds its
       height while the content changes, then eases to the new one */
    const h0 = swap.offsetHeight;
    if (!state.reduced) await play(form, { opacity: [1, 0], y: [0, -MO.riseXs] }, { duration: MO.quick, ease: MO.eExit })?.finished;
    showDone();
    const h1 = swap.offsetHeight;
    if (!state.reduced) play(swap, { height: [`${h0}px`, `${h1}px`] }, { duration: MO.slow, ease: MO.eStandard })?.finished.then(() => { swap.style.height = ''; });
    toast.focus({ preventScroll: true });
    announce(`You’re on the waitlist for ${variant.textContent}. We’ll email ${value} when it’s back.`);
    submit.removeAttribute('aria-busy');
    submitLabel.textContent = 'Keep Me Posted';
    sending = false;
  });

  return {
    /* { color, size, type, image } — the sold-out variant on the page */
    open(trigger, { color, size, type, image }) {
      key = `${product.id}:${color.slug}:${size}:${type}`;
      img.src = image;
      img.alt = `${product.plainName} in ${color.name}`;
      nameEl.textContent = product.plainName;
      variant.textContent = `${color.name} · ${SIZE_NAMES[size] || size} · ${type}`;
      email.value = '';
      email.removeAttribute('aria-invalid');
      error.hidden = true;
      const signedUp = joined.has(key);
      form.hidden = signedUp;
      done.hidden = !signedUp;
      root.querySelectorAll('[data-autofocus]').forEach((el) => el.removeAttribute('data-autofocus'));
      (signedUp ? toast : email).setAttribute('data-autofocus', '');
      if (signedUp) showDone({ instant: true });
      drawer.open(trigger);
      if (!state.reduced) {
        play([$('.wl__product', root), signedUp ? done : form], { opacity: [0, 1], y: [MO.riseXs, 0] },
          { duration: MO.base, ease: MO.eEntrance, delay: stagger(MO.stagTight, { startDelay: 0.16 }) });
      }
    },
    close: () => drawer.close(),
    get isOpen() { return drawer.isOpen; },
  };
}
